import { observer } from "mobx-react-lite";

import contentStore from "../../stores/cms/contentStore";
import segmentStore from "../../stores/cms/segmentStore";

import UrlImageLink from "./UrlImageLink";

type EntryImageLinkProps = {
   id: string;
   type: "article" | "recipe";
   imageWithFocusId?: string;
   title?: string;
   subTitle?: string;
   trackingListName?: string;
};

const EntryImageLink = ({ id, type, imageWithFocusId, title, subTitle, trackingListName }: EntryImageLinkProps) => {
   if (!segmentStore.isArticleVisible(id)) {
      return null;
   }

   if (!imageWithFocusId) {
      return null;
   }

   const urlData = contentStore.urlData.data.find((urlData) => urlData.id === id);
   const url = `/${urlData?.fullUrl}`;

   return (
      <UrlImageLink
         url={url}
         type={type}
         imageWithFocusId={imageWithFocusId}
         title={title}
         subTitle={subTitle}
         trackingListName={trackingListName}
      />
   );
};

export default observer(EntryImageLink);
